export default __webpack_public_path__ + "static/media/saint_aubin15.888655ef.jpg";